import type { RemoteSettings } from '../../../../types/src';
import { openApiInstances } from './openApis';

export const getRemoteSettings = () => openApiInstances.Config.get<RemoteSettings>('/api');
